import { defineStore } from "pinia";
import Services from '@/services/sacrificeDataServices'
import { mapSacrificeData } from '@/helpers/mapFuncs'

export const useSacrificeDataStore = defineStore("sacrificeData", {

state:()=>({
    sacrificeData: {},
    sacrificeDatas: [],
}),
getters : {
    getSacrificeData() {
        return mapSacrificeData(this.sacrificeData)
    },
    getSacrificeDatas() {
        return this.sacrificeDatas.map(mapSacrificeData)
    }
},
actions : {
    /** Start Sets */
    setSacrificeData(sacrificeData) {
        this.sacrificeData = sacrificeData
    },
    setSacrificeDatas(sacrificeDatas) {
        this.sacrificeDatas = sacrificeDatas
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setSacrificeData(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setSacrificeDatas(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setSacrificeDatas(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.sacrificeDatas.push(response.data.data)
            return mapSacrificeData(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.sacrificeDatas[this.sacrificeDatas.findIndex((x)=>x.id == id)] = response.data.data
            return mapSacrificeData(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.sacrificeDatas = this.sacrificeDatas.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});